export default  [
				{
          path: '',
          component: () => import( /* webpackChunkName: "search" */ '../../components/search/search-all.vue'),
          meta: { searchTopbar: true }
        },
        {
          path: 'profile/',
          name: 'profile',
          component: () => import( /* webpackChunkName: "search" */ '../../components/search/search-profile.vue'),
          meta: { searchTopbar: true }
        },
        {
          path: 'tags/',
          name: 'tags',
          component: () => import( /* webpackChunkName: "search" */ '../../components/search/search-tags.vue'),
          meta: { searchTopbar: true }
        }
 ]